import { FileUtils } from '../utils/file.utils';

export class HighchartHelpers {
  static getExportDataUrl = (tableContent: string): string => {
    const uri = 'data:application/vnd.ms-excel;base64,';
    const template =
      '<html xmlns:o="urn:schemas-microsoft-com:office:office" ' +
      'xmlns:x="urn:schemas-microsoft-com:office:excel" ' +
      'xmlns="http://www.w3.org/TR/REC-html40">' +
      '<head><!--[if gte mso 9]><xml><x:ExcelWorkbook>' +
      '<x:ExcelWorksheets><x:ExcelWorksheet>' +
      '<x:Name>Ark1</x:Name>' +
      '<x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions>' +
      '</x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook>' +
      '</xml><![endif]-->' +
      '<style>td{border:none;font-family: Calibri, sans-serif;} ' +
      '.number{mso-number-format:"0.00";} ' +
      '.text{ mso-number-format:"@";}</style>' +
      '<meta name=ProgId content=Excel.Sheet>' +
      '<meta charset=UTF-8>' +
      '</head><body>' +
      tableContent +
      '</body></html>';
    return `${uri}${window.btoa(decodeURIComponent(encodeURIComponent(template)))}`;
  };

  static getExportBlob = (tableContent: string): Blob => {
    const dataUrl = this.getExportDataUrl(tableContent);
    return FileUtils.spreadsheetDataURIToBlob(dataUrl);
  };
}
